import { DatabaseModel, ModelJson } from './database-model';

/**
 * Discount model used to store discount codes and prices in database
 */
export class Discount extends DatabaseModel {
    // Key
    public key: string = '';
    // Product key
    public productKey: string = '';
    // The (discounted) price API ID
    public stripePriceKey: string = '';
    // Code for the user to input to get discount
    public code: string = '';
    // New (discounted) product price in kr.
    public price: number = null;
    // Title to help users identify discount
    public title: string = '';

    constructor(json: any = null, key?: string) {
        super();

        if(json) this.fromJson(json);
        // Automatically assign keys to new objects
        if(!this.key) this.key = key || this.genKey();
    }

    /**
     * Convert database json to Discount instance (deserialize)
     */
    public fromJson(json): Discount {
        Object.assign(this, json);
        return this;
    }

    /**
     * Convert Discount instance to json (serialize)
     */
    public toJson(): ModelJson {
        let json = Object.assign({}, this);
        return json;
    }
}
